export function formatRublesFromMinorUnits(amountInMinorUnits: number): string {
  return (amountInMinorUnits / 100).toFixed(2);
}

export function rublesToMinorUnits(rubles: number): number {
  return Math.round(rubles * 100);
}
